(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@reduxjs/toolkit"), require("@normy/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@reduxjs/toolkit", "@normy/core"], factory);
	else if(typeof exports === 'object')
		exports["NormyRtkQuery"] = factory(require("@reduxjs/toolkit"), require("@normy/core"));
	else
		root["NormyRtkQuery"] = factory(root[undefined], root["Normy"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__693__, __WEBPACK_EXTERNAL_MODULE__700__) => {
return 